import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileRequestAccess = _resolveComponent("ProfileRequestAccess")!
  const _component_BlockMaxWidthHandler = _resolveComponent("BlockMaxWidthHandler")!

  return (_openBlock(), _createBlock(_component_BlockMaxWidthHandler, null, {
    default: _withCtx(() => [
      _createVNode(_component_ProfileRequestAccess, {
        class: "max-w-750 md:mx-auto",
        countries: _ctx.content.countries,
        "company-types": _ctx.content.companyTypes,
        "simple-form": true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            innerHTML: _ctx.content.confirmationText
          }, null, 8, _hoisted_1)
        ]),
        _: 1
      }, 8, ["countries", "company-types"])
    ]),
    _: 1
  }))
}